// src/api/apiUser.jsx
import { createAPI } from "./apiFactory";
const userAPI = createAPI("user_token", "/login");
export default userAPI;
